import React from 'react';
import Icon from './Icon';

interface EmptyStateProps {
  icon: string;
  title: string;
  sub?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, sub }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 24px',
    gap: 14,
  }}>
    <div style={{
      width: 64,
      height: 64,
      borderRadius: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--glass-bg)',
      border: '1px solid var(--glass-border)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
    }}>
      <Icon name={icon} size={28} color="var(--text3)" />
    </div>
    <div style={{ textAlign: 'center' }}>
      <p style={{ color: 'var(--text1)', fontWeight: 500, marginBottom: 4 }}>{title}</p>
      {sub && <p style={{ fontSize: 13, color: 'var(--text2)' }}>{sub}</p>}
    </div>
  </div>
);

export default EmptyState;
